var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-padded",attrs:{"id":"domain-product-definitions"}},[_c('Instruction',[_vm._v(" Contact support for additional product definitions. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }